import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Link from '../common/TrackedLink';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';
import LazyLoad from 'react-lazyload';

class CustomerStories extends Component {
	constructor(props) {
		super(props);
		this.state = {
			options: [],
			selected: null,
			readMore1: false,
			readMore2: false,
			readMore3: false,
			readMore4: false,
			readMore5: false,
			readMore6: false,
			readMore7: false,
			readMore8: false,
			readMore9: false,
			readMore10: false,
			readMore11: false,
			readMore12: false,

		};
	}

	handleClickReadMore1() {
		if (this.state.readMore1 === false) {
			this.setState({ readMore1: true });
		} else {
			this.setState({ readMore1: false });
		}
	}

	handleClickReadMore2() {
		if (this.state.readMore2 === false) {
			this.setState({ readMore2: true });
		} else {
			this.setState({ readMore2: false });
		}
	}

	handleClickReadMore3() {
		if (this.state.readMore3 === false) {
			this.setState({ readMore3: true });
		} else {
			this.setState({ readMore3: false });
		}
	}

	handleClickReadMore4() {
		if (this.state.readMore4 === false) {
			this.setState({ readMore4: true });
		} else {
			this.setState({ readMore4: false });
		}
	}

	handleClickReadMore5() {
		if (this.state.readMore5 === false) {
			this.setState({ readMore5: true });
		} else {
			this.setState({ readMore5: false });
		}
	}

	handleClickReadMore6() {
		if (this.state.readMore6 === false) {
			this.setState({ readMore6: true });
		} else {
			this.setState({ readMore6: false });
		}
	}

	handleClickReadMore7() {
		if (this.state.readMore7 === false) {
			this.setState({ readMore7: true });
		} else {
			this.setState({ readMore7: false });
		}
	}

	handleClickReadMore8() {
		if (this.state.readMore8 === false) {
			this.setState({ readMore8: true });
		} else {
			this.setState({ readMore8: false });
		}
	}

	handleClickReadMore9() {
		if (this.state.readMore9 === false) {
			this.setState({ readMore9: true });
		} else {
			this.setState({ readMore9: false });
		}
	} handleClickReadMore10() {
		if (this.state.readMore10 === false) {
			this.setState({ readMore10: true });
		} else {
			this.setState({ readMore10: false });
		}
	} handleClickReadMore11() {
		if (this.state.readMore11 === false) {
			this.setState({ readMore11: true });
		} else {
			this.setState({ readMore11: false });
		}
	} handleClickReadMore12() {
		if (this.state.readMore12 === false) {
			this.setState({ readMore12: true });
		} else {
			this.setState({ readMore12: false });
		}
	}

	render() {
		return (
			<div className="customer-stories">
				<Helmet>
					<title>Stories &#124; SentrySafe</title>
					<meta name="description"
						content="SentrySafe product owners share stories about their most precious valueables withstanding fire, water damage, robbery and more. View stories." />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem label="Learn" />
					<BreadcrumbItem label="Stories" />
				</Breadcrumb>

				<header className="row header-callout">
					<div className="col">
						<h1>SentrySafe Testimonials</h1>
						<p>Real stories of SentrySafes that have survived the toughest tests</p>
					</div>
				</header>

				<div className="row intro">
					<div className="col title">
						<p>Our safes are built to protect your most valuable, irreplaceable items in the event of theft, fire, or flood. We take pride in the quality of our products and more so, we understand the importance of peril protection for your valuables. SentrySafe is committed to designing products with protection for the unexpected that offer peace&#45;of&#45;mind for a lifetime.</p>
					</div>
				</div>

				<div className="row sub-heading">
					<div className="col md-7 pb-3 pb-md-0 pl-md-5">
						<p className="text-left">Our product owners share their personal stories and experience with fires, floods, break&#45;ins, and more.</p>
					</div>
					<div className="col md-5">
						<Link className="btn btn-primary" to="https://www.masterlock.com/testimonial#submit-your-story" target="_blank">
							Share Your Story
						</Link>
					</div>
				</div>

				<section className="row testimonial">
					<div className="col sm-7 descr">
						<img className="quote" src={require('../../resources/img/callouts/testimonial-quote-red.png')} alt="Quote" />
						<h2 className="title">The strength to begin again</h2>
						<h3 className="category">Document Safes</h3>
						<p>Time stood still for the McDermotts and others of Breezy Point, NY, as Hurricane Sandy leveled their homes, destroying all that they had. 190 firefighters were sent into the blaze engulfing the neighborhood. Over 100 home were lost in the course of the night.</p>
						<p> Later that week, the McDermotts walked the leveled neighborhood. All that was left of Rosemary&#39;s mother&#39;s home was the basement filled with the charred remnants of what had been. With so little left, they searched for some small fragment of hope to comfort her mother during this difficult time. They then found a charred box amongst the debris.</p>
						<p>It was her mom&#39;s SentrySafe Document Safe.</p>
						<p>Though burnt on the outside, it protected the items entrusted to its care, including their family geneology, a project Rosemary&#39;s mother had worked on for years.</p>
						<p>&quot;I knew my mother was going to be so, so, happy. She was coming down that day and I was so excited that we had something to show her that was going to make her feel so much better...that something was salvageable out of absolutely nothing.&quot;</p>
						<p><a href="https://players.brightcove.net/1213897989/default_default/index.html?videoId=5123091010001" target="_blank"><span className="fa fa-play-circle" aria-hidden="true" /> Watch the McDermotts Tell Their Story</a></p>
						<p><Link to="/document-safes">Learn more about our Document Safes.</Link></p>
					</div>
					<div className="col sm-5 image">
						<img src={require('../../resources/img/callouts/testimonial-page-callout.jpg')} alt="Man with file safe after disaster" />
					</div>
				</section>

				<div className="testimonial-quote">
					<p>
						&ldquo;You hear about people having fires, but you just don&rsquo;t understand
						what it&rsquo;s like to really lose everything that you have.&rdquo;
					</p>
					<p className="submission">Submitted by Rosemary M.</p>
				</div>

				<div className="accent-image">
					<LazyLoad once={true} offset={200}>
						<img
							src={require('../../resources/img/hero/testimonial-flood.jpg')}
							alt="Flooded Street"
						/>
					</LazyLoad>
				</div>

				<section className="row testimonial-cards">

					<div className="col sm-4">
						<div className="testimonial-card">
							<div className="testimonial-card-header">
								<h3 className="title">Powerful protection when disaster strikes</h3>
								<p className="category h4">
									<Link to="/products/fire-safes">Fire Safes</Link>
								</p>
								<p className="submission h4">Submitted by Joshua C.</p>
							</div>
							<div className={`testimonial-card-content ${this.state.readMore10 ? 'active' : ''}`}>
								<p>
									Years ago, we received a Sentry Safe as a wedding present. Recently, we experienced a
									winter house fire started by a fault in the wood stove flue.  The home was a total loss,
									along
									<span className="read-more-content"> with nearly all of its contents. We were shocked and delighted to see the Sentry
										Safe had survived the fire and protected our marriage/birth certificates, passports,
										vehicle titles, spare keys and back up hard drives. Making us Sentry Safe customers for life.<span className="cat-callout">
											<Link to="/products/fire-safes">Learn more about our UL Classified Fire Protection.</Link></span></span>
								</p>
								<button
									className="show-more-less"
									onClick={this.handleClickReadMore10.bind(this)}
								>
									{this.state.readMore10 ? 'Show Less' : 'Read More'}
									<span
										className={`fa ${this.state.readMore10 ? 'fa-angle-up' : 'fa-angle-down'}`}
										aria-hidden="true"
									/>
								</button>
							</div>
						</div>
					</div>
					<div className="col sm-4">
						<div className="testimonial-card">
							<div className="testimonial-card-header">
								<h3 className="title">Keeping memories safe</h3>
								<p className="category h4">
									<Link to="/products/fire-safes">Fire Safes</Link>
								</p>
								<p className="submission h4">Submitted by Steven D.</p>
							</div>
							<div className={`testimonial-card-content ${this.state.readMore11 ? 'active' : ''}`}>
								<p>
									I had a SentrySafe 1200 that survived my Condo fire that lasted 7 hours. I kept all my valuables in this product and I'm happy I did. Everything else was lost except this safe.
									<span className="read-more-content"> I swear by SentrySafe and their products!!! Thank you!!!<span className="cat-callout">
										<Link to="/products/fire-safes">Learn more about our UL Classified Fire Protection.</Link></span></span>
								</p>
								<button
									className="show-more-less"
									onClick={this.handleClickReadMore11.bind(this)}
								>
									{this.state.readMore11 ? 'Show Less' : 'Read More'}
									<span
										className={`fa ${this.state.readMore11 ? 'fa-angle-up' : 'fa-angle-down'}`}
										aria-hidden="true"
									/>
								</button>
							</div>
						</div>
					</div>
					<div className="col sm-4">
						<div className="testimonial-card">
							<div className="testimonial-card-header">
								<h3 className="title">Powerful protection when disaster strikes</h3>
								<p className="category h4">
									<Link to="/products/fire-safes">Fire Safes</Link>
								</p>
								<p className="submission h4">Submitted by Jason F.</p>
							</div>
							<div className={`testimonial-card-content ${this.state.readMore12 ? 'active' : ''}`}>
								<p>
									I've owned the 3100 safe since I was 9 or 10 years old. Recently had a house fire where we lost everything. Two story home burned all the way to the basement. Our safe, fell through 2 floors and
									<span className="read-more-content"> was trapped in the rubble for 4 days before being retrieved. After letting it cool down, we cut through the steel to see if anything survived. To my surprise, everything inside the safe was saved! All of our personal files and hd drives we protected!!!! Will buy again!<span className="cat-callout">
										<Link to="/products/fire-safes">Learn more about our UL Classified Fire Protection.</Link></span></span>
								</p>
								<button
									className="show-more-less"
									onClick={this.handleClickReadMore12.bind(this)}
								>
									{this.state.readMore12 ? 'Show Less' : 'Read More'}
									<span
										className={`fa ${this.state.readMore12 ? 'fa-angle-up' : 'fa-angle-down'}`}
										aria-hidden="true"
									/>
								</button>
							</div>
						</div>
					</div>
				</section>
				<section className="row testimonial-cards">

					<div className="col sm-4">
						<div className="testimonial-card">
							<div className="testimonial-card-header">
								<h3 className="title">Powerful Protection When Disaster Strikes</h3>
								<p className="category h4">
									<Link to="/fire-waterproof-safes">Fireproof Safes</Link>
								</p>
								<p className="submission h4">Submitted by Marshall E.</p>
							</div>
							<div className={`testimonial-card-content ${this.state.readMore7 ? 'active' : ''}`}>
								<p>
									My father&rsquo;s home in Punta Gorda FL burnt completely to the ground...
									His home along with 6 others lost everything!!!
									The only thing the firemen retrieved after 2 days of burning
									<span className="read-more-content">
										was my father&rsquo;s safe.
										I cut the safe open and found everything intact. The safe was on the second floor
										and was found under the rubble the following day.
										I cut the safe open, and as you can see his belongings were safe.
										<span className="cat-callout">
											<Link to="/fire-waterproof-safes">Learn about fireproof safes.</Link>
										</span>
									</span>
								</p>
								<button
									className="show-more-less"
									onClick={this.handleClickReadMore7.bind(this)}
								>
									{this.state.readMore7 ? 'Show Less' : 'Read More'}
									<span
										className={`fa ${this.state.readMore7 ? 'fa-angle-up' : 'fa-angle-down'}`}
										aria-hidden="true"
									/>
								</button>
							</div>
						</div>
					</div>

					<div className="col sm-4">
						<div className="testimonial-card">
							<div className="testimonial-card-header">
								<h3 className="title">Security That Stands Tough</h3>
								<p className="category h4">
									<Link to="/fire-waterproof-safes">Fireproof Safes</Link>
								</p>
								<p className="submission h4">Submitted by Mark C.</p>
							</div>
							<div className={`testimonial-card-content ${this.state.readMore8 ? 'active' : ''}`}>
								<p>
									I can&rsquo;t say enough great things about my SentrySafe...
									My small business was burgled late one night.
									I arrived to find my safe had been stolen from the premises...
									the safe was <span className="read-more-content">
										found within 30 minutes and although the safe had been thrown down and the thief
										had tried hard to pry the safe open, my SentrySafe stood firm...
										Based upon this experience...I went right back to my retailer and bought another SentrySafe...
										I&rsquo;m a fan for life!
										<span className="cat-callout">
											<Link to="/fire-waterproof-safes">Learn about fireproof safes.</Link>
										</span>
									</span>
								</p>
								<button
									className="show-more-less"
									onClick={this.handleClickReadMore8.bind(this)}
								>
									{this.state.readMore8 ? 'Show Less' : 'Read More'}
									<span
										className={`fa ${this.state.readMore8 ? 'fa-angle-up' : 'fa-angle-down'}`}
										aria-hidden="true"
									/>
								</button>
							</div>
						</div>
					</div>

					<div className="col sm-4">
						<div className="testimonial-card">
							<div className="testimonial-card-header">
								<h3 className="title">Powerful Protection When Disaster Strikes</h3>
								<p className="category h4">
									<Link to="/fire-waterproof-safes">Fireproof Safes</Link>
								</p>
								<p className="submission h4">Submitted by Michael M.</p>
							</div>
							<div className={`testimonial-card-content ${this.state.readMore9 ? 'active' : ''}`}>
								<p>
									I was finally able to recover my second safe after a devastating house fire.
									Even though it was not rated for water the contents came out relatively dry despite the fire,
									flooding from putting the fire out and
									<span className="read-more-content">
										&nbsp;months of being buried in wet debris from the months of rain since the fire.
										As soon as I can afford I will have a large water rated SentrySafe.
										Thanks for securing my irreplaceable items.
										I will never trust anyone but SentrySafe to protect my valuables.
										<span className="cat-callout">
											<Link to="/fire-waterproof-safes">Learn about fireproof safes.</Link>
										</span>
									</span>
								</p>
								<button
									className="show-more-less"
									onClick={this.handleClickReadMore9.bind(this)}
								>
									{this.state.readMore9 ? 'Show Less' : 'Read More'}
									<span
										className={`fa ${this.state.readMore9 ? 'fa-angle-up' : 'fa-angle-down'}`}
										aria-hidden="true"
									/>
								</button>
							</div>
						</div>
					</div>
				</section >
				<section className="row testimonial-cards">
					<div className="col sm-4">
						<div className="testimonial-card">
							<div className="testimonial-card-header">
								<h3 className="title">Powerful protection when disaster strikes</h3>
								<p className="category h4">
									<Link to="/products/fire-waterproof-safes">Fireproof Safes</Link>
								</p>
								<p className="submission h4">Submitted by Tracy L.</p>
							</div>
							<div className={`testimonial-card-content ${this.state.readMore1 ? 'active' : ''}`}>
								<p>
									We had a SentrySafe that survived the Paradise, CA wildfire in 2018.  We
									found it 3 weeks later in the ashes of our home after the fire destroyed
									our entire town... after 3 weeks of torrential rain
									<span className="read-more-content"> storms immediately
										following the fire.  Once we retrieved our safe, we took it to the local fire
										station, because we needed the "jaws of life" to pry our safe open.  Once we
										got through the metal and concrete, we pulled out our unscathed belongings,
										including a hand gun, paper documents, pictures, and old coins.  We could not
										believe everything was okay!  Everyone we talk to says their safes melted, or
										whatever was inside melted.  Just to put into perspective how hot this fire
										got...our car melted into the concrete of our garage.  There was nothing left of
										our house or belongings, other than our SentrySafe.  We would like to purchase
										another safe for our new home.  Thank you for being such a great company and
										taking care of your customers! <span className="cat-callout">
											<Link to="/products/fire-waterproof-safes">Learn more about our fireproof safes.</Link></span></span>
								</p>
								<button
									className="show-more-less"
									onClick={this.handleClickReadMore1.bind(this)}
								>
									{this.state.readMore1 ? 'Show Less' : 'Read More'}
									<span
										className={`fa ${this.state.readMore1 ? 'fa-angle-up' : 'fa-angle-down'}`}
										aria-hidden="true"
									/>
								</button>
							</div>
						</div>
					</div>
					<div className="col sm-4">
						<div className="testimonial-card">
							<div className="testimonial-card-header">
								<h3 className="title">Keeping memories safe</h3>
								<p className="category h4">
									<Link to="/products/fire-waterproof-safes">Fireproof Safes</Link>
								</p>
								<p className="submission h4">Submitted by Nicole D.</p>
							</div>
							<div className={`testimonial-card-content ${this.state.readMore2 ? 'active' : ''}`}>
								<p>
									I wanted to send a note of thanks!  Our moving truck caught fire and your
									safe was all that survived.  We just arrived today and broke open the
									charred safe to find our hard drive with all
									<span className="read-more-content"> my kids’ childhood pictures
										was completely perfect.  Please share my thanks within your company.  We
										are truly grateful to each person who was a part of keeping those pictures
										safe.  Thank you!  We will be buying a new SentrySafe to keep our memories
										safe. <span className="cat-callout"><Link to="/products/fire-waterproof-safes">Learn more about
											our fireproof safes</Link>.</span></span>
								</p>
								<button
									className="show-more-less"
									onClick={this.handleClickReadMore2.bind(this)}
								>
									{this.state.readMore2 ? 'Show Less' : 'Read More'}
									<span
										className={`fa ${this.state.readMore2 ? 'fa-angle-up' : 'fa-angle-down'}`}
										aria-hidden="true"
									/>
								</button>
							</div>
						</div>
					</div>
					<div className="col sm-4">
						<div className="testimonial-card">
							<div className="testimonial-card-header">
								<h3 className="title">Powerful protection when disaster strikes</h3>
								<p className="category h4">
									<Link to="/products/fire-waterproof-safes">Fireproof Safes</Link>
								</p>
								<p className="submission h4">Submitted by Victoria L.</p>
							</div>
							<div className={`testimonial-card-content ${this.state.readMore3 ? 'active' : ''}`}>
								<p>
									I’d love to share our story with you all. We suffered a total loss fire in our home
									and our SentrySafe protected our most treasured valuables. We cannot say enough to
									thank you for making a wonderful
									<span className="read-more-content">  product. Everything inside of it was completely
										dry. We now need to get a new one because this is the ONLY brand we will trust
										moving forward. <span className="cat-callout"><Link to="/products/fire-waterproof-safes">Learn more
											about our fireproof safes.</Link></span></span>
								</p>
								<button
									className="show-more-less"
									onClick={this.handleClickReadMore3.bind(this)}
								>
									{this.state.readMore3 ? 'Show Less' : 'Read More'}
									<span
										className={`fa ${this.state.readMore3 ? 'fa-angle-up' : 'fa-angle-down'}`}
										aria-hidden="true"
									/>
								</button>
							</div>
						</div>
					</div>
				</section>
				<section className="row testimonial-cards">
					<div className="col sm-4">
						<div className="testimonial-card">
							<div className="testimonial-card-header">
								<h3 className="title">Security that stands tough</h3>
								<p className="category h4">
									<Link to="/security-safes">Security Safes</Link>
								</p>
								<p className="submission h4">Submitted by Richard D.</p>
							</div>
							<div className={`testimonial-card-content ${this.state.readMore4 ? 'active' : ''}`}>
								<p>
									Richard was the victim of a burglary where the suspects attempted to break
									into his pistol safe. They used a sledge hammer while attempting to open
									the safe, breaking off the keypad and
									<span className="read-more-content"> handle, and rendering the key useless.
										When it was clear they wouldn&rsquo;t be able to gain entry to the safe from
										the front, the suspects tried unsuccessfully to break the hinges off. Once
										Richard recovered his firearms from inside the badly damaged, but unopened
										safe, he found they were completely protected. After that, Richard says,
										&ldquo;I immediately went and bought a brand new SentrySafe
										pistol safe just like the old one.&rdquo; <span className="cat-callout">
											<Link to="/security-safes">Learn more about the strength of our Security Safes.</Link></span></span>
								</p>
								<button
									className="show-more-less"
									onClick={this.handleClickReadMore4.bind(this)}
								>
									{this.state.readMore4 ? 'Show Less' : 'Read More'}
									<span
										className={`fa ${this.state.readMore4 ? 'fa-angle-up' : 'fa-angle-down'}`}
										aria-hidden="true"
									/>
								</button>
							</div>
						</div>
					</div>
					<div className="col sm-4">
						<div className="testimonial-card">
							<div className="testimonial-card-header">
								<h3 className="title">Keeping memories safe</h3>
								<p className="category h4">
									<Link to="/fire-safes">Fire Safes</Link>
								</p>
								<p className="submission h4">Submitted by Jami H.</p>
							</div>
							<div className={`testimonial-card-content ${this.state.readMore5 ? 'active' : ''}`}>
								<p>
									&ldquo;I purchased a small SentrySafe fire chest while I was
									in college. I had some pictures and important papers stored in it.&rdquo;
									After college, Jami continued storing important documents like her
									<span className="read-more-content"> marriage certificate, birth certificates
										and social security cards in the safe as well. Then after having children, she
										began collecting sentimental items like their first locks of hair, baby teeth
										and pictures. In short, Jami&rsquo;s small safe became the place where she kept
										her most valuable possessions. So when a fire ripped through her home destroying
										everything, she expected the worst. To her surprise, her fire chest survived.
										&ldquo;The outside was a little charred, but the contents were in one piece.
										My little safe is the only thing that made me smile through the days following
										our fire.&rdquo; Jami was able to pry open the safe and recover her important
										documents and photos &ndash; the only photos from the home that survived the fire.
										&ldquo;Without these few pictures, I would have nothing from my kids childhood.
										We are rebuilding and I will be buying another SentrySafe Fire Safe.
										A <span className="uppercase">huge</span> one.&ldquo; <span className="cat-callout"><Link to="/fire-safes">Learn more about
											our UL Classified Fire Protection.</Link></span></span>
								</p>
								<button
									className="show-more-less"
									onClick={this.handleClickReadMore5.bind(this)}
								>
									{this.state.readMore5 ? 'Show Less' : 'Read More'}
									<span
										className={`fa ${this.state.readMore5 ? 'fa-angle-up' : 'fa-angle-down'}`}
										aria-hidden="true"
									/>
								</button>
							</div>
						</div>
					</div>
					<div className="col sm-4">
						<div className="testimonial-card">
							<div className="testimonial-card-header">
								<h3 className="title">Powerful protection when disaster strikes</h3>
								<p className="category h4">
									<Link to="/security-safes">Security Safes</Link>
								</p>
								<p className="submission h4">Submitted by Janet M.</p>
							</div>
							<div className={`testimonial-card-content ${this.state.readMore6 ? 'active' : ''}`}>
								<p>
									Janet&rsquo;s 87-year-old mother&rsquo;s house was leveled when an EF5 tornado &ndash;
									the most powerful rating for a tornado &#45; tore through the town of Joplin, MO.
									However, Janet&rsquo;s mom kept a small security
									<span className="read-more-content"> safe with important documents in a closet in one
										of her rooms. &quot;It was in a room that was totally emptied by the storm. We never
										found any of the furniture that was in that room, but this safe was found in my
										mother&rsquo;s yard, opened and upside down.&quot; Despite being opened by the sheer
										power of the storm, all the contents of the safe were found with minimal damage
										underneath the overturned safe in the yard. And the best part? Janet&rsquo;s mother
										is still using the safe in her new home today. <span className="cat-callout"><Link to="/security-safes">Learn more
											about our Security Safes.</Link></span></span>
								</p>
								<button
									className="show-more-less"
									onClick={this.handleClickReadMore6.bind(this)}
								>
									{this.state.readMore6 ? 'Show Less' : 'Read More'}
									<span
										className={`fa ${this.state.readMore6 ? 'fa-angle-up' : 'fa-angle-down'}`}
										aria-hidden="true"
									/>
								</button>
							</div>
						</div>
					</div>
				</section>

			</div >
		);
	};
}

export default CustomerStories;


// WEBPACK FOOTER //
// ./src/pages/learn/CustomerStories.js